import { useMemo } from "react";
import { useApiList } from "@/queries/base/useApiList";

/**
 * Dropdown hook for customers.
 * GET /customer
 */
export function useCustomerOptions() {
  const { data, isLoading, error } = useApiList("/customer", []);

  const options = useMemo(() => {
    return data.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  }, [data]);
  return { options, isLoading, error };
}
